import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import { Col, Container, Row, Button } from 'reactstrap';
import AlertModal from '../../../../../shared/components/Modal';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Spinner from 'react-bootstrap/Spinner';


const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ActivityVisitsPatient = ({ data, enableLucnhAndTransport, enableActivitiesList, closeOpenActivityVisit, opened, id_estudio_paciente, callbackActivityPatientStudio }) => {

    //Atributos
    const [admision, setAdmision] = React.useState(data);
    const [activities, setActivities] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [updateMode, setUpdateMode] = React.useState(false);
    const [idStudyPatient, setIdStudyPatient] = React.useState(id_estudio_paciente);

    //Alerta
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const checkedDays = [];

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    React.useEffect(() => {
        let actividades = listActivities(data.id_visita);
    }, []);

    //Lista las actividades de la visita del presupuesto
    const listActivities = async (id_visita) => {
        setIsLoading(true);
        let url = `visitas/${id_visita}/actividades`;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(dataResponse => {
            let actividades = [];
            for (let i = 0; i < dataResponse.contenido.length; i++) {
                dataResponse.contenido[i].id = i;
                dataResponse.contenido[i].costo_original = dataResponse.contenido[i].costo;

                if (dataResponse.check_transporte == true) {
                    dataResponse.contenido[i].id_admision = admision.id_admision;
                    dataResponse.contenido[i].check = true;
                }
                else {
                    dataResponse.contenido[i].id_admision = null;
                    dataResponse.contenido[i].check = false;
                }
                dataResponse.contenido[i].disabled = false;
                actividades.push(dataResponse.contenido[i]);
            }
            listVisitActivities(actividades);
        }).catch(err => {
            console.log(err);
            setActivities([]);
            setIsLoading(false);
        });
    }

    //Lista las actividades de la Visita en el Control de la Admision
    const listVisitActivities = async (actividades) => {
        let url = "visitas-admision/consultar-visita";
        url += "?"
        url += `id_admision=${admision.id_admision}&`
        url += `id_visita=${admision.id_visita}`
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(visita_admision => {
            if (visita_admision.existe == true && visita_admision.contenido != null) {
                dejarCamposSoloLecturaAdmision(visita_admision, actividades);
                setUpdateMode(true);
            }
            else {
                verifyActivities(actividades);
            }
        }).catch(err => {
            alertModal(false, "Ha ocurrido un error en el sistema");
            console.log(err);
            setIsLoading(false);
        });
    }

    //Lista las actividades de la Visita en el Control de la Visita
    const verifyActivities = async (actividades) => {
        let url = "visitas-admision/verificar-visita";
        url += "?"
        url += `id_visita=${admision.id_visita}`
        url += `&id_admision=${admision.id_admision}`
        url += `&id_estudio_paciente=${id_estudio_paciente}`

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(visita_paciente => {
            if (visita_paciente.existe == true && visita_paciente.contenido != null) {
                dejarCamposSoloLecturaVisita(visita_paciente, actividades);
            }
            else {
                setActivities(actividades);
                setIsLoading(false);
            }
        }).catch(err => {
            alertModal(false, "Ha ocurrido un error en el sistema");
            console.log(err);
            setIsLoading(false);
        });
    }

    const dejarCamposSoloLecturaAdmision = (visita_admision, actividades) => {
        let nuevasActividades = [];

        //Se selecciona todas las actividades
        for (let i = 0; i < visita_admision.contenido.actividades.actividades.length; i++) {
            visita_admision.contenido.actividades.actividades[i].disabled = false;
            nuevasActividades.push(visita_admision.contenido.actividades.actividades[i]);
        }

        for (let k = visita_admision.contenido.actividades.actividades.length; k < actividades.length; k++) {
            nuevasActividades.push(actividades[k]);
            actividades[k].disabled = true;
        }
        setActivities(nuevasActividades);
        setIsLoading(false);
    }

    const dejarCamposSoloLecturaVisita = (visita_paciente, actividades) => {
        let nuevasActividades = [];
        for (let i = 0; i < visita_paciente.contenido.actividades.actividades.length; i++) {

            //Costo original en Transporte, Refrigerio, Hospedaje o otros
            if (visita_paciente.contenido.actividades.actividades[i].check_transporte != undefined) {
                if (visita_paciente.contenido.actividades.actividades[i].check_transporte == true) {

                    visita_paciente.contenido.actividades.actividades[i].costo = visita_paciente.contenido.actividades.actividades[i].costo_original;
                }
            }

            //Si pertenece a una Admision deshabilite
            if (visita_paciente.contenido.actividades.actividades[i].id_admision != null) {
                if (visita_paciente.contenido.actividades.actividades[i].check_transporte != undefined) {
                    if (visita_paciente.contenido.actividades.actividades[i].check_transporte == true) {

                        visita_paciente.contenido.actividades.actividades[i].costo = visita_paciente.contenido.actividades.actividades[i].costo_original;
                        visita_paciente.contenido.actividades.actividades[i].disabled = false;
                    }
                    else {
                        visita_paciente.contenido.actividades.actividades[i].disabled = true;
                    }
                }
                else {
                    visita_paciente.contenido.actividades.actividades[i].disabled = true;
                }
            }
            else {
                visita_paciente.contenido.actividades.actividades[i].disabled = false;
            }
            nuevasActividades.push(visita_paciente.contenido.actividades.actividades[i]);
        }

        for (let k = visita_paciente.contenido.actividades.actividades.length; k < actividades.length; k++) {
            nuevasActividades.push(actividades[k]);
            actividades[k].disabled = false;
        }

        setActivities(nuevasActividades);
        setIsLoading(false);
    }

    //Cambia el Checkbox Seleccionado
    const handleChangeActivity = (actividad, check) => {
        if (check == true) {
            activities[actividad.id].id_admision = admision.id_admision;
        }
        else {
            activities[actividad.id].id_admision = null;
        }
        activities[actividad.id].check = check;
    }

    //Cambia el Checkbox Seleccionado
    const handleChangeCostActivity = (actividad, value) => {
        activities[actividad.id].costo = parseInt(value);
    }

    const submitActivities = () => {
        try {
            saveAdmisionVisit()
        }
        catch (err) {
            alertModal(false, "Ha ocurrido un error");
        }
    }

    const saveAdmisionVisit = async () => {
        let JSONSend =
        {
            id_paciente: data.id_paciente,
            id_visita: data.id_visita,
            id_admision: data.id_admision,
            actividades: activities,
            id_estudio: data.id_estudio,
            id_estudio_paciente: id_estudio_paciente
        }

        let url = `visitas-admision/create`;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(JSONSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                response.json();
            }
            else {
                throw new Error("Error de Consulta");
            }
        }).then(dataResp => {
            alertModal(true, "Actividades seleccionadas correctamente");
        }).catch(err => {
            console.log(err);
            alertModal(false, "Ha ocurrido un error en el sistema");
        });
    }

    const updateAdmisionVisit = async () => {
        let JSONSend =
        {
            id_admision: data.id_admision,
            actividades: activities,
            id_estudio_paciente: id_estudio_paciente
        }

        let url = `visitas-admision/update`;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(JSONSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                response.json();
            }
            else {
                throw new Error("Error de Consulta");
            }
        }).then(data => {
            alertModal(true, "Actividades actualizadas correctamente");
            console.log(data);
        }).catch(err => {
            alertModal(false, "Ha ocurrido un error en el sistema");
            console.log(err);
        });
    }

    const CheckboxVisits = () => {
        let _row = [];
        let transporte = [];
        activities.map((item, i) => {
            if (item.check_transporte == true) {
                if (enableLucnhAndTransport == true) {
                    transporte.push(
                        <Col md={4}>
                            <TextField
                                required
                                style={{ margin: 10, width: 200 }}
                                id={item.id + "txtTransporte"}
                                label={item.nombre}
                                disabled={item.disabled}
                                defaultValue={item.costo}
                                type="number"
                                className="medical-material-form__field"
                                onChange={(e) => {
                                    handleChangeCostActivity(item, e.target.value);
                                }}
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            />
                        </Col>);
                }
            }
            else {

                if (enableActivitiesList == true) {
                    _row.push(
                        <FormControlLabel
                            value={item}
                            disabled={item.disabled}
                            control={
                                item.id_admision == null ?
                                    <MedicalCheckbox
                                        defaultChecked={activities[item.id].check == true ? true : false}
                                        onChange={(event, check) => {
                                            handleChangeActivity(item, check);
                                        }}
                                        iconStyle={{ fill: 'green' }} />
                                    :

                                    item.id_admision == admision.id_admision ?
                                        <MedicalCheckbox
                                            defaultChecked={activities[item.id].check == true ? true : false}
                                            onChange={(event, check) => {
                                                handleChangeActivity(item, check);
                                            }}
                                            iconStyle={{ fill: 'green' }} />
                                        :
                                        <Checkbox
                                            defaultChecked={activities[item.id].check == true ? true : false}
                                            onChange={(event, check) => {
                                                handleChangeActivity(item, check);
                                            }}
                                            iconStyle={{ fill: 'green' }} />
                            }
                            label={item.nombre}
                        />
                    );
                }

            }
        });

        return (
            <div>
                <FormGroup style={{ maxHeight: '100px' }} aria-label="position" row>
                    {_row}
                </FormGroup>
                <br /><br />
                <Row>
                    {transporte}
                </Row>
            </div>

        );
    }

    return (
        <React.Fragment>


            <Modal
                open={opened}
                onClose={e => {
                    closeOpenActivityVisit(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div style={{ textAlign: 'center' }}>
                        <div>

                            <div>
                                <div className="card__title">
                                    <h5 className="bold-text">Checkeo de Actividades</h5>
                                </div>

                                <Row>
                                    {
                                        isLoading == false ? <CheckboxVisits />
                                            :
                                            <div className="text-center">
                                                <Spinner animation="border" variant="success" />
                                            </div>
                                    }
                                </Row>
                            </div>


                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10, marginRight: 10 }}
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                if(updateMode == true)
                                {
                                    updateAdmisionVisit();
                                }
                                else
                                {
                                    submitActivities();
                                }
                            }}
                        >
                            {
                                updateMode == true ? "Actualizar" : "Confirmar"
                            }
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            color="secondary"
                            onClick={() => {
                                closeOpenActivityVisit();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => {
                    setAlerShowModal(false);
                    if (colorAlertModal == "success") {
                        closeOpenActivityVisit();
                        callbackActivityPatientStudio(data.id_admision, true, idStudyPatient);
                    }
                }}
                toggle={() => {
                    setAlerShowModal(false);
                    if (colorAlertModal == "success") {
                        closeOpenActivityVisit();
                        callbackActivityPatientStudio(data.id_admision, true, idStudyPatient);
                    }
                }}
            />

        </React.Fragment>
    );
};
export default ActivityVisitsPatient;
